import styled from 'styled-components';

export default styled.div`
  padding: 40px 20px 30px;
  text-align: center;

  > p {
    margin-block: 22px 30px;
  }
`;
